// components/ContinueButtons.jsx - Functional Continue Buttons
import React from 'react';
import { Button } from 'react-bootstrap';
import NumberFormat from 'react-number-format';
import BottomNavigation from './BottomNavigation';
import BottomNavigationCart from './BottomNavigationMarket';

const ContinueButtons = ({ user, translate, totals, totalForNotLogginUser, onNext, onBackToStore }) => {
  if (user['is_teammate'] === null) {
    return null;
  }

  return (
    <>
      {/* Mobile Buttons */}
      <div className='continue-ordering-row d-sm-none' style={{ marginTop: '20px', paddingBottom: '30px' }}>
        <BottomNavigationCart translate={translate} onNext={onNext} user={user} totals={totals} totalForNotLogginUser={totalForNotLogginUser} />
      </div>

      {/* Desktop Buttons */}
      <div className='mt-3 d-none d-sm-block' style={{ marginTop: '20px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Button onClick={onNext} style={{ background: 'var(--main_green_dark)', fontSize: '14px', padding: '8px 16px' }}>
            {translate('next-cart')}
          </Button>
          <Button onClick={onBackToStore} className='main-bg-color' style={{ fontSize: '14px', padding: '8px 16px' }}>
            {translate('back-cart')}
          </Button>
        </div>
      </div>
    </>
  );
};

export default ContinueButtons;
